import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from 'react';
import moment from 'moment';
import { $l } from 'choerodon-ui/pro/lib/locale-context';
import intl from "../../utils/intl";
import notification from "../../utils/notification";
import { getAccessToken, getAttachmentUrl, getCurrentOrganizationId, getResponse, isTenantRoleLevel } from "../../utils/utils";
import request from "../../utils/request";
import { getEnvConfig } from "../../utils/iocUtils";
import { queryFileList, queryUUID, removeFile } from "../../services/api";
import AttachmentHistory from "./AttachmentHistory";
var newUrlPreviewList = ['dot', 'dotx', 'dotm', 'odt', 'fodt', 'ott', 'rtf', 'txt', 'html', 'htm', 'mht', 'djvu', 'fb2', 'epub', 'xps', 'xls', 'xlsx', 'xlsm', 'xlt', 'xltx', 'xltm', 'ods', 'fods', 'ots', 'csv', 'pps', 'ppsx', 'ppsm', 'ppt', 'pptx', 'pptm', 'pot', 'potx', 'potm', 'odp', 'fodp', 'otp'];
var attachmentConfig = {
  defaultFileKey: 'file',
  defaultFileSize: 500 * 1024 * 1024,
  action: function action(_ref) {
    var bucketName = _ref.bucketName,
      bucketDirectory = _ref.bucketDirectory,
      attachmentUUID = _ref.attachmentUUID;
    var _getEnvConfig = getEnvConfig(),
      HZERO_FILE = _getEnvConfig.HZERO_FILE;
    var accessToken = getAccessToken();
    var headers = {
      'Access-Control-Allow-Origin': '*',
      processData: false,
      // 不会将 data 参数序列化字符串
      // method: 'POST',
      type: 'FORM',
      responseType: 'text'
    };
    if (accessToken) {
      headers.Authorization = "bearer ".concat(accessToken);
    }
    var data = {
      attachmentUUID: attachmentUUID
    };
    if (bucketName) {
      data.bucketName = bucketName;
    }
    if (bucketDirectory) {
      data.directory = bucketDirectory;
    }
    return {
      url: isTenantRoleLevel() ? "".concat(HZERO_FILE, "/v1/").concat(getCurrentOrganizationId(), "/files/attachment/multipart-with-info") : "".concat(HZERO_FILE, "/v1/files/attachment/multipart-with-info"),
      headers: headers,
      data: data
    };
  },
  fetchList: function fetchList(_ref2) {
    var attachmentUUID = _ref2.attachmentUUID,
      bucketName = _ref2.bucketName,
      bucketDirectory = _ref2.bucketDirectory;
    return queryFileList({
      tenantId: getCurrentOrganizationId(),
      bucketName: bucketName,
      directory: bucketDirectory,
      attachmentUUID: attachmentUUID
    }).then(function (response) {
      if (getResponse(response)) {
        return response.map(function (file) {
          return _objectSpread({}, file, {
            uid: file.fileId,
            name: file.fileName,
            size: file.fileSize,
            type: file.fileType,
            url: file.fileUrl,
            creationDate: moment(file.creationDate).toDate(),
            status: 'done'
          });
        });
      }
      throw new Error(response && response.message);
    });
  },
  batchFetchCount: function batchFetchCount(attachmentUUIDs) {
    var _getEnvConfig2 = getEnvConfig(),
      HZERO_FILE = _getEnvConfig2.HZERO_FILE;
    return request("".concat(HZERO_FILE, "/v1/").concat(getCurrentOrganizationId(), "/files/count/batch"), {
      method: 'POST',
      body: attachmentUUIDs
    });
  },
  onRemove: function onRemove(_ref3) {
    var attachment = _ref3.attachment,
      attachmentUUID = _ref3.attachmentUUID,
      bucketName = _ref3.bucketName,
      bucketDirectory = _ref3.bucketDirectory;
    return removeFile({
      tenantId: getCurrentOrganizationId(),
      bucketName: bucketName,
      directory: bucketDirectory,
      attachmentUUID: attachmentUUID,
      urls: [attachment.url]
    }).then(function (res) {
      if (getResponse(res)) {
        notification.success({
          duration: 2,
          placement: 'bottomRight',
          message: intl.get('hzero.common.notification.success')
        });
        return true;
      }
      notification.error({
        duration: 2,
        placement: 'bottomRight',
        message: intl.get('hzero.common.notification.error')
      });
      return false;
    });
  },
  onOrderChange: function onOrderChange(_ref4) {
    var attachments = _ref4.attachments,
      bucketName = _ref4.bucketName,
      bucketDirectory = _ref4.bucketDirectory,
      attachmentUUID = _ref4.attachmentUUID;
    var _getEnvConfig3 = getEnvConfig(),
      HZERO_FILE = _getEnvConfig3.HZERO_FILE;
    request("".concat(HZERO_FILE, "/v1/").concat(getCurrentOrganizationId(), "/files/").concat(attachmentUUID, "/file/order"), {
      method: 'POST',
      body: attachments.map(function (attachment) {
        return attachment.uid;
      }),
      query: {
        bucketName: bucketName,
        directory: bucketDirectory
      }
    });
  },
  getAttachmentUUID: function getAttachmentUUID() {
    return queryUUID({
      tenantId: getCurrentOrganizationId()
    }).then(function (result) {
      return result.content;
    });
  },
  getDownloadUrl: function getDownloadUrl(_ref5) {
    var attachment = _ref5.attachment,
      bucketName = _ref5.bucketName,
      bucketDirectory = _ref5.bucketDirectory,
      redirectDownload = _ref5.redirectDownload;
    return getAttachmentUrl(attachment.url, bucketName, getCurrentOrganizationId(), bucketDirectory, undefined, redirectDownload);
  },
  getPreviewUrl: function getPreviewUrl(_ref6) {
    var attachment = _ref6.attachment,
      bucketName = _ref6.bucketName,
      bucketDirectory = _ref6.bucketDirectory,
      storageCode = _ref6.storageCode,
      redirectDownload = _ref6.redirectDownload;
    var ext = attachment.ext,
      type = attachment.type,
      url = attachment.url;
    var tenantId = getCurrentOrganizationId();
    if (type.startsWith('image')) {
      return getAttachmentUrl(url, bucketName, tenantId, bucketDirectory, undefined, redirectDownload);
    }
    var _getEnvConfig4 = getEnvConfig(),
      HZERO_FILE = _getEnvConfig4.HZERO_FILE; // eslint-disable-next-line no-nested-ternary

    var prevewUrl = newUrlPreviewList.includes(ext) ? isTenantRoleLevel() ? "".concat(HZERO_FILE, "/v1/").concat(tenantId, "/file/preview") : "".concat(HZERO_FILE, "/v1/file/preview") : isTenantRoleLevel() ? "".concat(HZERO_FILE, "/v1/").concat(tenantId, "/file-preview/by-url") : "".concat(HZERO_FILE, "/v1/file-preview/by-url");
    return "".concat(prevewUrl, "?url=").concat(encodeURIComponent(url), "&bucketName=").concat(bucketName).concat(storageCode ? "&storageCode=".concat(storageCode) : '', "&access_token=").concat(getAccessToken());
  },
  onUploadSuccess: function onUploadSuccess(resp, attachment) {
    attachment.load(_objectSpread({}, resp, {
      uid: resp.fileId,
      name: resp.fileName,
      size: resp.fileSize,
      type: resp.fileType,
      url: resp.fileUrl,
      creationDate: moment(resp.creationDate).toDate()
    }));
    notification.success({
      duration: 2,
      placement: 'bottomRight',
      message: $l('Upload', 'upload_success')
    });
  },
  onUploadError: function onUploadError() {},
  renderIcon: function renderIcon(attachment, listType) {
    if (listType === 'text') {
      var ext = attachment.ext,
        type = attachment.type;
      if (type.startsWith('image')) {
        return require("../../assets/attachment-icons/icon_img.svg");
      }
      if (type === 'application/pdf') {
        return require("../../assets/attachment-icons/icon_pdf.svg");
      }
      if (type.startsWith('video') || type.startsWith('audio')) {
        return require("../../assets/attachment-icons/icon_mov.svg");
      }
      if (['application/zip', 'application/x-zip-compressed', 'application/x-compressed'].includes(type) || ['rar', 'zip', 'tgz', '7z'].includes(ext)) {
        return require("../../assets/attachment-icons/icon_zip.svg");
      }
      if (['ppt', 'pptx', 'pot', 'pps', 'dps', 'dpt'].includes(ext)) {
        return require("../../assets/attachment-icons/icon_ppt.svg");
      }
      if (['xls', 'xlsx', 'xlsm', 'csv', 'xlt', 'et', 'ett'].includes(ext)) {
        return require("../../assets/attachment-icons/icon_excel.svg");
      }
      if (['doc', 'docx', 'dot', 'wps', 'wpt'].includes(ext)) {
        return require("../../assets/attachment-icons/icon_word.svg");
      }
      if (['doc', 'docx', 'dot', 'wps', 'wpt'].includes(ext)) {
        return require("../../assets/attachment-icons/icon_word.svg");
      }
      if (['txt', 'conf'].includes(ext)) {
        return require("../../assets/attachment-icons/icon_txt.svg");
      }
      if (['java', 'JAVA', 'js', 'ts', 'jsx', 'tsx', 'html', 'css', 'sql', 'yml'].includes(ext)) {
        return require("../../assets/attachment-icons/icon_code.svg");
      }
      return require("../../assets/attachment-icons/icon_unknow.svg");
    }
  },
  renderHistory: function renderHistory(_ref7) {
    var attachment = _ref7.attachment;
    return /*#__PURE__*/React.createElement(AttachmentHistory, {
      attachment: attachment
    });
  }
};
export default attachmentConfig;